import styled from "styled-components"

export default {
    "ModalBackground": styled.div`
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        align-items: end;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 50;
    `,

    "Modal": styled.div`
        background-color: ${({ theme }) => theme.color["white"]};
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 32px 28px;
        border-radius: 20px 20px 0px 0px;
    `,

    "TitleDiv": styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;

        h2 {
            ${({ theme }) => theme.font["large-semibold"]};
        }

        button {
            width: 12px;
            height: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    `,
}